export default {
  ["EXACT_VAL"](state, val) {
    state.exact_checkbox = val;
  },
};
